<template>
    <div>
        <b-tabs v-model="tabIndex">
            <b-tab active>
                <template slot="title">
                    Procesamiento                
                </template>
                <template v-if="tabIndex == 0">
                    <pedidos :tab="tabIndex" @tabindex="changeTab"></pedidos>
                </template>
            </b-tab>
            <b-tab title="Almacen">
                <template v-if="tabIndex == 1">
                    <pedidos :tab="tabIndex" @tabindex="changeTab"></pedidos>                
                </template>
            </b-tab>
            <b-tab title="Delivery">
                <template v-if="tabIndex == 2">
                    <pedidos :tab="tabIndex" @tabindex="changeTab"></pedidos>                
                </template>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import Pedidos from '@/components/gestion/PedidosLista'
    export default {
        name: '',
        components: {
            Pedidos
        },
        data:() => {
            return {
                tabIndex: 0
            }
        },
        methods: {
            changeTab(value){
                this.tabIndex = value
            }
        }
    }
</script>

<style>

</style>